import React, { useState, useEffect, createRoot } from 'react';
import weblogo from '../Images/logo.png';
import Userimg from '../Images/icons8-user-50.png';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

function AccountBtn(props) {

    // INITIALIZATION OF USERNAME VAR AND GETLOCALSTORAGE FUNCTION
    const [UsernameVar, setUsernameVar] = useState([]);
    const getLocalStorage = (name) => {
        const storedValue = localStorage.getItem(name);
        return storedValue ? JSON.parse(storedValue) : null;
    };


    // HANDLE SIGNUP AND LOGOUT:
    const navigate = useNavigate();
    function handleSignup() {
        navigate('/signup')
        window.scrollTo(0, 0);
    }

    function handleLogout() {
        console.log('logging out')
        window.scrollTo(0, 0);

        localStorage.removeItem('UserName')
        localStorage.removeItem('UserEmail')
        localStorage.removeItem('UserPassword')
        window.location.reload()
    }



    // LOGIN BUTTON OR ACCOUNT BUTTON LOGIC:
    useEffect(() => {
        const Username = getLocalStorage('UserName');
        const AccountBtn = document.getElementById(`${props.id}-parent-Account-button`)
        const LoginBtn = document.getElementById(`${props.id}-parent-Login-button`)
        try {
            if (Username) {
                setUsernameVar(Username)
                AccountBtn.style.display = 'block'
                LoginBtn.style.display = 'none'
            }
        } catch (error) {
            console.log('Error Occuered in loading the Account-Btn');
        }
    }, [])


    return (
        <div className="login-btn" id={props.id}>
            <div className="login-signup-btn" onClick={handleSignup} id={`${props.id}-parent-Login-button`}>
                Login/SignUp
            </div>
            <div className='position-raltive parent-Account-button' id={`${props.id}-parent-Account-button`}>
                <div className='Account-button'>
                    <div className="Account-button-pfp">
                        <img src={Userimg} alt="" />
                    </div>
                    <div className="accountinfo">
                        <div className="acin">
                            {UsernameVar}
                        </div>
                        <div className="acip">
                            Account and Orders
                        </div>
                    </div>
                </div>
                <div className="Account-menu">
                    <div className="Account-menu-ul">
                        <div className="am-menu-list" onClick={() => navigate('/orders')}>
                            <i className="fas fa-box-open"></i>
                            Orders
                        </div>
                        <div className="am-menu-list" onClick={handleLogout}>
                            <i className="fas fa-sign-out-alt"></i>
                            LogOut
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountBtn;